module.exports = __webpack_public_path__ + "static/404@2x-9aa688187b41f29d1db6b77ce0b74cc0.png";